module.exports = __webpack_public_path__ + "media/application/images/2018/nav-sidebar-lock-cf93544e7bad23020d057f1ae83fb48a.svg";